module.exports = [{
      plugin: require('/Users/wojtekwrotek/BLAZITY/M7-pages/atrium-katowice/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
